export default __webpack_public_path__ + "static/media/Icon-Proposals.42cb7ca9.svg";